import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCaldas from '../components/MenuCaldas';
import Sponsors from '../components/Sponsors';
import ProgessTitle from '../components/ProgressTitle';
import useInputValue from '../hooks/useInputValue';
import useCheckValue from '../hooks/useCheckValue';
import '../assets/styles/containers/CompleteRegister.sass';

const CompleteRegister = () => {
  const [modal, setModal] = useState('none');
  const [sponsors, setSponsors] = useState(null);
  const type_id = useInputValue('');
  const number = useInputValue('');
  const blood_group = useInputValue('');
  const eps = useInputValue('');
  const nacionality = useInputValue('');
  const sex = useInputValue('');
  const birthday_day = useInputValue('');
  const birthday_month = useInputValue('');
  const birthday_year = useInputValue('');
  const address = useInputValue('');
  const city = useInputValue('');
  const country = useInputValue('');
  const emergency_contact_name = useInputValue('');
  const emergency_contact_number = useInputValue('');
  const jersey_size = useInputValue('');
  const t_shirt_size = useInputValue('');
  const race_aim = useInputValue('');
  const instagram = useInputValue('');
  const know = useInputValue('');
  const medical_conditions = useInputValue('');
  const liability_disclaimer = useCheckValue(false);
  const rules_and_regulations = useCheckValue(false);
  const terms_and_conditions = useCheckValue(false);
  const medical = useCheckValue(false);
  const signature = useInputValue('');
  const [errors, setErrors] = useState();
  const [email, setEmail] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/sponsors/caldas`)
    .then(res => res.json())
    .then(
      (res) => {
        setSponsors(res.sponsors);
      },
      (error) => {
        console.error(error);
      }
    )
  }, []);

  useEffect(() => {
    const session = sessionStorage.getItem('la-leyenda');
    const data = JSON.parse(session);
    if (data.signature) {
      type_id.setValue(data.type_id);
      number.setValue(data.number);
      blood_group.setValue(data.blood_group);
      eps.setValue(data.eps);
      nacionality.setValue(data.nacionality);
      sex.setValue(data.sex);
      birthday_day.setValue(data.birthday_day);
      birthday_month.setValue(data.birthday_month);
      birthday_year.setValue(data.birthday_year);
      address.setValue(data.address);
      city.setValue(data.city);
      country.setValue(data.country);
      emergency_contact_name.setValue(data.emergency_contact_name);
      emergency_contact_number.setValue(data.emergency_contact_number);
      jersey_size.setValue(data.jersey_size);
      t_shirt_size.setValue(data.t_shirt_size);
      race_aim.setValue(data.race_aim);
      instagram.setValue(data.instagram);
      know.setValue(data.know);
      medical_conditions.setValue(data.medical_conditions);
      liability_disclaimer.setChecked(data.liability_disclaimer);
      rules_and_regulations.setChecked(data.rules_and_regulations);
      terms_and_conditions.setChecked(data.terms_and_conditions);
      medical.setChecked(data.medical);
      signature.setValue(data.signature);
      setEmail(data.email);
    } else {
      setEmail(data.email.value);
    }
  }, []);

  const handleOpenModal = () => {
    setModal('block');
  }

  const handleCloseModal = () => {
    setModal('none');
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!number) {
      return;
    }

    let formData = new FormData();
    formData.append("type_id", type_id.value);
    formData.append("number", number.value);
    formData.append("blood_group", blood_group.value);
    formData.append("eps", eps.value);
    formData.append("nacionality", nacionality.value);
    formData.append("sex", sex.value);
    formData.append("birthday_day", birthday_day.value);
    formData.append("birthday_month", birthday_month.value);
    formData.append("birthday_year", birthday_year.value);
    formData.append("address", address.value);
    formData.append("city", city.value);
    formData.append("country", country.value);
    formData.append("emergency_contact_name", emergency_contact_name.value);
    formData.append("emergency_contact_number", emergency_contact_number.value);
    formData.append("jersey_size", jersey_size.value);
    formData.append("t_shirt_size", t_shirt_size.value);
    formData.append("race_aim", race_aim.value);
    formData.append("instagram", instagram.value);
    formData.append("know", know.value);
    formData.append("medical_conditions", medical_conditions.value);
    formData.append("liability_disclaimer", liability_disclaimer.checked);
    formData.append("rules_and_regulations", rules_and_regulations.checked);
    formData.append("terms_and_conditions", terms_and_conditions.checked);
    formData.append("medical", medical.checked);
    formData.append("signature", signature.value);
    formData.append("email", email);

    fetch(`${process.env.REACT_APP_URL}/inscripcion`, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
      headers:{
        'Content-Type': 'application/json'
      }
    })
    .then(data => data.json())
    .then(data => {
      if (data.errors) {
        return setErrors(data.errors);
      }
      return redirectSession();
    })
    .catch(err => setErrors(err));

  }

  const redirectSession = () => {
    const save = {
      'type_id': type_id.value,
      'number': number.value,
      'blood_group': blood_group.value,
      'eps': eps.value,
      'nacionality': nacionality.value,
      'sex': sex.value,
      'birthday_day': birthday_day.value,
      'birthday_month': birthday_month.value,
      'birthday_year': birthday_year.value,
      'address': address.value,
      'city': city.value,
      'country': country.value,
      'emergency_contact_name': emergency_contact_name.value,
      'emergency_contact_number': emergency_contact_number.value,
      'jersey_size': jersey_size.value,
      't_shirt_size': t_shirt_size.value,
      'race_aim': race_aim.value,
      'instagram': instagram.value,
      'know': know.value,
      'medical_conditions': medical_conditions.value,
      'liability_disclaimer': liability_disclaimer.checked,
      'rules_and_regulations': rules_and_regulations.checked,
      'terms_and_conditions': terms_and_conditions.checked,
      'medical': medical.checked,
      'signature': signature.value,
      'email': email
    };
    
    sessionStorage.setItem("la-leyenda", JSON.stringify(save));
    window.location.href = "/series/caldas/registro/validar-informacion";
  }

  return (
    <Layout>
      <Banner id={13} city="caldas" thumb="/caldas/logo_caldas.png" />
      <MenuCaldas />
      <ProgessTitle step2="active" city="caldas"/>
      <div className="row CompleteRegister content-caldas">
        <div className="container">

          {/* Form */}
          <div className="row my-4">
            <div className="col-12">
              <form onSubmit={event => handleSubmit(event)}>

                <div className="form-group row">
                  <label htmlFor="type_id" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tipo de documento</label>
                  <div className="col-md-6">
                    <select name="type_id" className={`form-control ${errors?.type_id ? 'is-invalid' : ''}`} {...type_id}>
                      <option value="">Seleccione</option>
                      <option value="Passport">Pasaporte</option>
                      <option value="ID Card">Tarjeta de identificación</option>
                      <option value="Cedula de ciudadania">Cédula de ciudadania</option>
                      <option value="Cedula de extranjeria">Cédula de extranjeria</option>
                    </select>
                    <span className="help-block red">{errors?.type_id ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="number" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Documento No.</label>
                  <div className="col-md-6">
                    <input id="number" type="text" className={`form-control ${errors?.number ? 'is-invalid' : ''}`} name="number" {...number} />
                    <span className="help-block red">{errors?.number ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="blood_group" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Tipo de sangre</label>
                  <div className="col-md-6">
                    <select name="blood_group" className={`form-control ${errors?.blood_group ? 'is-invalid' : ''}`} {...blood_group} >
                      <option value="">Seleccione</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="dont know">No lo sé</option>
                    </select>
                    <span className="help-block red">{errors?.blood_group ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="eps" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Proveedor de seguro médico / EPS</label>
                  <div className="col-md-6">
                    <input id="eps" type="text" className={`form-control ${errors?.eps ? 'is-invalid' : ''}`} name="eps" {...eps} />
                    <span className="help-block red">{errors?.eps ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="nacionality" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Nacionalidad</label>
                  <div className="col-md-6">
                    <input id="nacionality" type="text" className={`form-control ${errors?.nacionality ? 'is-invalid' : ''}`} name="nacionality" {...nacionality} />
                    <span className="help-block red">{errors?.nacionality ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="sex" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Sexo</label>
                  <div className="col-md-6">
                    <select name="sex" className={`form-control ${errors?.sex ? 'is-invalid' : ''}`} {...sex} >
                      <option value="">Seleccione</option>
                      <option value="Hombre">Hombre</option>
                      <option value="Mujer">Mujer</option>
                    </select>
                    <span className="help-block red">{errors?.sex ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="birthday" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Fecha de nacimiento</label>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-3 mb-3 mb-md-0">
                        <input id="birthday" type="text" className={`form-control ${errors?.birthday_day ? 'is-invalid' : ''}`} name="birthday_day" placeholder="Día" {...birthday_day} />
                      </div>
                      <div className="col-md-5 mb-3 mb-md-0">
                        <select name="birthday_month" className={`form-control ${errors?.birthday_month ? 'is-invalid' : ''}`} {...birthday_month} >
                          <option value="">Seleccione</option>
                          <option value="01">Enero</option>
                          <option value="02">Febrero</option>
                          <option value="03">Marzo</option>
                          <option value="04">Abril</option>
                          <option value="05">Mayo</option>
                          <option value="06">Junio</option>
                          <option value="07">Julio</option>
                          <option value="08">Agosto</option>
                          <option value="09">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </select>
                      </div>
                      <div className="col-md-4 mb-3 mb-md-0">
                        <input id="birthday" type="text" className={`form-control ${errors?.birthday_year ? 'is-invalid' : ''}`} name="birthday_year" value="" placeholder="Año" {...birthday_year}/>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="address" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Dirección</label>
                  <div className="col-md-6">
                    <input id="address" type="text" className={`form-control ${errors?.address ? 'is-invalid' : ''}`} name="address" {...address} />
                    <span className="help-block red">{errors?.address ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="city" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Ciudad</label>
                  <div className="col-md-6">
                    <input id="city" type="text" className={`form-control ${errors?.city ? 'is-invalid' : ''}`} name="city" {...city} />
                    <span className="help-block red">{errors?.city ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="country" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> País</label>
                  <div className="col-md-6">
                    <input id="country" type="text" className={`form-control ${errors?.country ? 'is-invalid' : ''}`} name="country" {...country} />
                    <span className="help-block red">{errors?.country ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="emergency_contact_name" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Acudiente en caso de emergencia</label>
                  <div className="col-md-6">
                    <input id="emergency_contact_name" type="text" className={`form-control ${errors?.emergency_contact_name ? 'is-invalid' : ''}`} name="emergency_contact_name" {...emergency_contact_name} />
                    <span className="help-block red">{errors?.emergency_contact_name ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="emergency_contact_number" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Teléfono acudiente con código de área</label>
                  <div className="col-md-6">
                    <input id="emergency_contact_number" type="text" className={`form-control ${errors?.emergency_contact_number ? 'is-invalid' : ''}`} name="emergency_contact_number" {...emergency_contact_number} />
                    <span className="help-block red">{errors?.emergency_contact_number ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="jersey_size" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Talla de Jersey (Específico de género)</label>
                  <div className="col-md-2 mb-3 mb-md-0">
                    <select name="jersey_size" className={`form-control ${errors?.jersey_size ? 'is-invalid' : ''}`} {...jersey_size} >
                      <option value="">Seleccione</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                    </select>
                    <span className="help-block red">{errors?.jersey_size ? 'Requerido' : ''}</span>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-ll --caldas" onClick={() => handleOpenModal()}>Guía de Tallas Jersey kafitt</button>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="t-shirt_size" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Talla de camiseta (Específico de género)</label>
                  <div className="col-md-6">
                    <select name="t-shirt_size" className={`form-control ${errors?.t_shirt_size ? 'is-invalid' : ''}`} {...t_shirt_size} >
                      <option value="">Seleccione</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                    </select>
                    <span className="help-block red">{errors?.t_shirt_size ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="race_aim" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Objetivo</label>
                  <div className="col-md-6">
                    <select name="race_aim" className={`form-control ${errors?.race_aim ? 'is-invalid' : ''}`} {...race_aim} >
                      <option value="">Seleccione</option>
                      <option value="to win">Ganar</option>
                      <option value="podium">Podio</option>
                      <option value="top 10">Primeros 10</option>
                      <option value="to finish">Terminar</option>
                    </select>
                    <span className="help-block red">{errors?.race_aim ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="instagram" className="col-md-5 col-form-label text-md-right">Usuario Instagram</label>
                  <div className="col-md-6">
                    <input id="instagram" type="text" className="form-control" name="instagram" {...instagram} />
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="know" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> ¿Cómo supiste sobre La Leyenda?</label>
                  <div className="col-md-6">
                    <select name="know" className={`form-control ${errors?.know ? 'is-invalid' : ''}`} {...know} >
                      <option value="">Seleccione</option>
                      <option value="Word of mouth">Recomendación de un amigo/familiar/conocido</option>
                      <option value="Social networks">Redes Sociales</option>
                      <option value="Article in press">Artículo en prensa</option>
                      <option value="Printed publicity">Publicidad impresa</option>
                      <option value="Other">Otro</option>
                    </select>
                    <span className="help-block red">{errors?.know ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="medical_conditions" className="col-md-5 col-form-label text-md-right">¿Tiene alguna condición médica, alergias o requerimientos dietéticos especiales que debemos tener en cuenta?</label>
                  <div className="col-md-6">
                    <textarea name="medical_conditions" id="medical_conditions" cols="30" rows="5" className="form-control" {...medical_conditions}></textarea>
                  </div>
                </div>

                <div className="col-12 text-justify">
                  <p><b>Exoneración de Responsabilidades e Indemnización, Reglamento, Términos y Condiciones y Seguro Médico</b></p>
                  <p>Por favor leer los siguientes documentos de exoneración de responsabilidades e indemnización, reglamento, y términos y condiciones cuidadosamente. Ellos incluyen exención de responsabilidad y renuncia a derechos legales, y le privan de la habilidad de demandar a determinadas partes. Al darle aceptación electrónicamente, usted reconoce que ha leído y entendido todos estos documentos que hacen parte del proceso de inscripción.</p>
                </div>
                <div className="col-12">
                  <div>
                    <div className="radio">
                      <label>
                        <span className="red">*</span>
                        <input type="checkbox" name="liability_disclaimer" id="liability_disclaimer" {...liability_disclaimer} />
                        Acepto <a href="https://legendofeldorado.com/series/documents/formato_de_exoneracion.pdf" target="blank"> La Leyenda Series Formato de Exoneración de Responsibilidad e Indemnización</a>
                      </label>
                      <span className="help-block red ml-1">{errors?.liability_disclaimer ? 'Requerido' : ''}</span>
                    </div>
                  </div>

                  <div>
                    <div className="radio">
                      <label>
                        <span className="red">*</span>
                        <input type="checkbox" name="rules_and_regulations" id="rules_and_regulations" {...rules_and_regulations} />
                        Acepto <a href="https://legendofeldorado.com/series/documents/reglamento.pdf" target="blank">La Leyenda Series Reglamento</a>
                      </label>
                      <span className="help-block red ml-1">{errors?.rules_and_regulations ? 'Requerido' : ''}</span>
                    </div>
                  </div>

                  <div>
                    <div className="radio">
                      <label>
                        <span className="red">*</span>
                        <input type="checkbox" name="terms_and_conditions" id="terms_and_conditions" {...terms_and_conditions} />
                        Acepto <a href="https://legendofeldorado.com/series/documents/terminos_y_condiciones.pdf" target="blank">La Leyenda Series Términos y Condiciones </a>
                      </label>
                      <span className="help-block red ml-1">{errors?.terms_and_conditions ? 'Requerido' : ''}</span>
                    </div>
                  </div>

                  <div>
                    <div className="radio">
                      <label>
                        <span className="red">*</span>
                        <input type="checkbox" name="medical" id="medical" {...medical} />
                        Declaro tener un Seguro Médico apropiado
                      </label>
                      <span className="help-block red ml-1">{errors?.medical ? 'Requerido' : ''}</span>
                    </div>
                  </div>
                </div>

                <div className="col-12 text-justify">
                  <p>Ingresando mi nombre aquí, confirmo haber leído y estar de acuerdo con el documento de exoneración de responsabilidades e indemnización, el reglamento, y los términos y condiciones que he seleccionado, y confirmo tener un seguro médico apropiado. Acepto que mis datos, como aparecen en el formato de inscripción, sean utilizados para fines de la carrera. Confirmo que toda la información que he suministrado es correcta. Acepto las especificaciones de la carrera y la exoneración de responsabilidades por parte de los organizadores por cualquier tipo de daños. No haré reclamos contra los organizadores, los patrocinadores, o sus representantes por daños o lesiones de ningún tipo que sean incurridos por mí o mi compañero de equipo, como resultado de la participación en este evento. Ratifico haber seguido un entrenamiento apropiado para participar en esta carrera de múltiples etapas y que estoy en buena condición física. El personal médico o los directivos de la carrera están autorizados para retirarme de la carrera si detectaran cualquier signo alarmante de mal estado de salud.</p>
                </div>

                <div className="form-group row">
                  <label htmlFor="signature" className="col-md-5 col-form-label text-md-right"><span className="red">*</span> Firma electrónica (nombre completo)</label>
                  <div className="col-md-6">
                    <input id="signature" type="text" className="form-control" name="signature" {...signature} />
                    <span className="help-block red">{errors?.signature ? 'Requerido' : ''}</span>
                  </div>
                </div>

                <div className="form-group row justify-content-end">
                  <div className="col-md-3">
                    <input type="hidden" name="email" value={email} />
                    <button type="submit" className="btn btn-ll --caldas">CONTINUAR</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div className="modal fade show" id="tallasModal" tabindex="-1" role="dialog" aria-labelledby="tallasModalLabel" aria-modal="true" style={{display: modal}}>
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="tallasModalLabel">Guía de Tallas Jersey kafitt</h5>
                <button type="button" className="close" onClick={() => handleCloseModal()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <img className="img-fluid" src="https://legendofeldorado.com/series/img/tallas.jpg" alt="" />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => handleCloseModal()}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>

      </div>
      {sponsors &&
        <Sponsors
          customClass="--caldas"
          items={sponsors}
        />
      }
    </Layout>
  );
}

export default CompleteRegister;
